import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const EnterpriseIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "48",
                height: "48",
                rx: "6.73684",
                fill: "#6C6CFF"
            }),
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_506_4041)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M19.4766 19.6274V20.4603",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M19.4766 22.959V23.7918",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M19.4766 26.2903V27.1231",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M23.8486 19.6274V20.4603",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M23.8486 22.959V23.7918",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M23.8486 26.2903V27.1231",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M28.2207 19.6274V20.4603",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M28.2207 22.959V23.7918",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M28.2207 26.2903V27.1231",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M31.3445 17.1292V33.3693H16.3535V17.1292",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M29.2623 17.1291V14.6306H18.4355V17.1291",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M33.2182 33.3691H14.4795",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M32.3855 17.1292H15.3125",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M19.4766 29.6216V30.4544",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M28.2207 29.6216V30.4544",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M25.5149 33.3693V31.2872C25.5149 30.3711 24.7654 29.6216 23.8493 29.6216C22.9331 29.6216 22.1836 30.3711 22.1836 31.2872V33.3693",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_506_4041",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "19.9879",
                        height: "19.9879",
                        fill: "white",
                        transform: "translate(13.8545 14.0059)"
                    })
                })
            })
        ]
    });
